import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { supabase } from '../lib/supabaseClient';

const marketData = [
  {
    name: 'Cimiez',
    price: '6 800 €/m²',
    address: 'Avenue des Arènes de Cimiez',
    growth: '+3.2% sur 1 an',
    imageKey: 'market/cimiez.jpg'
  },
  {
    name: 'Carré d\'Or',
    price: '8 500 €/m²',
    address: 'Boulevard Victor Hugo',
    growth: '+4.5% sur 1 an',
    imageKey: 'market/carre-or.jpg'
  },
  {
    name: 'Vieux Nice',
    price: '5 900 €/m²',
    address: 'Cours Saleya',
    growth: '+2.8% sur 1 an',
    imageKey: 'market/vieux-nice.jpg'
  },
  {
    name: 'Cagnes-sur-Mer',
    price: '4 950 €/m²',
    address: 'Bord de Mer',
    growth: '+3.8% sur 1 an',
    imageKey: 'market/cagnes-sur-mer.jpg'
  },
  {
    name: 'Villefranche-sur-Mer',
    price: '7 200 €/m²',
    address: 'Vieille Ville',
    growth: '+5.2% sur 1 an',
    imageKey: 'market/villefranche.jpg'
  },
  {
    name: 'Antibes',
    price: '6 100 €/m²',
    address: 'Cap d\'Antibes',
    growth: '+4.1% sur 1 an',
    imageKey: 'market/antibes.jpg'
  }
];

export default function MarketTrends() {
  const [imageUrls, setImageUrls] = React.useState<Record<string, string>>({});

  React.useEffect(() => {
    const loadImages = async () => {
      const urls: Record<string, string> = {};
      for (const item of marketData) {
        const { data: { publicUrl } } = supabase.storage
          .from('app-img')
          .getPublicUrl(item.imageKey);
        urls[item.imageKey] = publicUrl;
      }
      setImageUrls(urls);
    };

    loadImages();
  }, []);

  return (
    <div className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900">
            Les tendances du marché immobilier à Nice et ses environs
          </h2>
          <p className="mt-4 text-lg text-gray-700">
            Découvrez les dernières tendances du marché immobilier dans les quartiers et villes les plus prisés de la Côte d'Azur
          </p>
        </div>

        <div className="mt-10">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={3}
            navigation
            pagination={{ clickable: true }}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            loop={true}
            className="market-trends-swiper"
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 20
              },
              640: {
                slidesPerView: 2,
                spaceBetween: 20
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 30
              }
            }}
          >
            {marketData.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="bg-white/80 backdrop-blur-xl shadow-[0_8px_32px_rgba(42,67,101,0.15)]
                  transform hover:scale-[1.02] transition-all duration-300
                  relative overflow-hidden rounded-xl"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      className="h-full w-full object-cover transform transition-transform duration-300 hover:scale-110"
                      src={imageUrls[item.imageKey]}
                      alt={`${item.name}`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                  </div>
                  <div className="p-6 relative z-10">
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{item.name}</h3>
                    <div className="space-y-2">
                      <p className="text-2xl font-bold bg-gradient-to-r from-[#2A4365] via-[#4A5568] to-[#C4A052] bg-clip-text text-transparent">
                        {item.price}
                      </p>
                      <p className="text-gray-700">
                        {item.address}
                      </p>
                      <p className="text-[#2A4365] font-semibold">
                        {item.growth}
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <style>{`
        .market-trends-swiper {
          padding: 20px 40px !important;
        }
        .swiper-button-next,
        .swiper-button-prev {
          color: #2A4365 !important;
        }
        .swiper-pagination-bullet-active {
          background: #2A4365 !important;
        }
      `}</style>
    </div>
  );
}